export const IMAGE_EXTENSIONS = new Set([
  'jpg', 'jpeg', 'png', 'webp', 'bmp', 'gif', 'tiff', 'tif', 'svg', 'avif', 'ico',
]);

export const COMPRESSIBLE_EXTENSIONS = new Set([
  'jpg', 'jpeg', 'png', 'webp', 'bmp', 'gif', 'tiff', 'tif', 'avif',
]);

export const MAX_CONCURRENT = 20;

export const COMPRESSION_OPTIONS = {
  alwaysKeepResolution: true,
  useWebWorker: true,
};


export function getExtension(filename: string): string {
  return filename.split('.').pop()?.toLowerCase() ?? '';
}

export function isImage(filename: string): boolean {
  return IMAGE_EXTENSIONS.has(getExtension(filename));
}

export function isCompressible(filename: string): boolean {
  return COMPRESSIBLE_EXTENSIONS.has(getExtension(filename));
}

export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}
